//? ESLint is disabled so that the constants remain on a single line.
/* eslint-disable */

export const TRACKING_URL = "https://www.shipnow.com.ar/track";

//? FAQS
export const BUYER_FAQS = "https://www.shipnow.com.ar/ayuda";
export const SELLER_FAQS = "https://shipnow.notion.site/18bf196bd1344262a9a3f72341757e1e?v=f9f9911ea53e4e508ae5639eac8ef6fb";
export const SHIPCROSS_GUIDE = "https://shipnow.notion.site/Qu-es-Shipcross-8fabf8e1516345d9a5c946693271ba17";
export const SHIPFULL_GUIDE = "https://shipnow.notion.site/Qu-es-Shipfull-c39245bf56dd484ab56ab16c63ea68d5";

//? FAQS Cambios
export const EXCHANGE_TYPES_FAQS =
  "https://www.notion.so/shipnow/Tipos-de-cambios-146fdac5368580acb8e5c8e33bd149a8";
export const EXCHANGE_FAQS =
  "https://www.notion.so/shipnow/Retornos-2e6196f10b214dbd91328ade69313a85#20afdac5368580ef8cc9ed23960498bf";
export const EXCHANGE_ZONES_FAQS =
  "https://www.notion.so/shipnow/En-qu-zonas-hacemos-cambios-1a7fdac5368580eb9ee8ddfcb033d67e";

// Correo Argentino CPs
export const SEARCH_CP = "https://www.correoargentino.com.ar/formularios/cpa";

export const FAQS_CPS_RETURN =
  "https://shipnow.notion.site/En-qu-zonas-hacemos-devoluciones-b8a0cea8b2834f85a1bc374852df434f";
export const FAQS_GOODINS_LABELS =
  "https://www.notion.so/shipnow/C-mo-etiquetar-un-pedido-para-una-recolecci-n-a5643dd39079436dbb504f08040f38f3?pvs=4";
export const PRIVACY_POLICIES =
  "https://shipnow-assets-production.s3.amazonaws.com/webapp/politicas-privacidad.pdf";

//? NPS
export const GOOGLE_OPINION = "https://g.page/r/CTGYkVBn-S8JEAg/review";
